export default __webpack_public_path__ + "static/media/200_4V_TECNOLOGIA_INGENIERA_SUPERIOR_01.9011b88d.jpg";